jQuery(document).ready(function($){
  
  $(window).scroll(function() {    

      var scroll = $(window).scrollTop();

      if (scroll >= 825) {
          $(".buy_tickets_btn").addClass("sticky-btn");
      } else {
          $(".buy_tickets_btn").removeClass("sticky-btn");
      }
  });

  $(window).scroll(function() {    

      var scroll2 = $(window).scrollBottom();

      if (scroll2 <= 85) {
          $(".buy_tickets_btn").removeClass("sticky-btn");
      }
  });
  
});